<div class="page_heading">
    <div class="container">
        <h2>{{detail?.heading}}</h2>
    </div>
</div>
<app-banner [BannerData]="bannerArray"></app-banner>


<!-- -------------------------our-business Section Start----------------- -->
<section class="our-business rs-section pd" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-dots rs-dots--pink rs-dots--c"></span>
    <span class="rs-spark" style="--sx: 8%; --sy: 40%; --sd: 0.5s"></span>
    <span class="rs-spark" style="--sx: 90%; --sy: 24%; --sd: 2.1s"></span>
  </div>

  <div class="rs-shell">
    <header class="row our-business-heading mt-0 pd__head" rsReveal="up">
      <div class="col-sm-12">
        <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">What you get</span>
        <h2>{{detail?.heading}} <span class="rs-title-grad">Features</span></h2>
        <!-- <span>Top Rated SEO Agency in India</span> -->
      </div>
    </header>

    <div class="pd__steps">
      <div class="row content-one mt-5 pd__step" rsReveal="up">
        <div class="col-sm-6 center-line pd__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img1}}" alt="product-detail">
          </div>
          <div class="s-no">
            <span>01</span>
          </div>
        </div>
        <div class="col-sm-6 googleRanking pd__copy">
          <div class="float">
            <h3>{{detail?.features?.featureDetail?.title1 }}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p>{{detail?.features?.featureDetail?.features1}}</p>
          </div>
        </div>
      </div>

      <div class="row content-one mt-0 pd__step pd__step--flip" rsReveal="up">
        <div class="col-sm-6 localseoservice pd__copy">
          <div class="float-l">
            <h3>{{detail?.features?.featureDetail?.title2}}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p class="one-p">{{detail?.features?.featureDetail?.features2}}</p>
          </div>
        </div>
        <div class="col-sm-6 center-line-l pd__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img2}}" alt="product-detail">
          </div>
          <div class="s-no-l">
            <span>02</span>
          </div>
        </div>
      </div>

      <div class="row content-one mt-0 pd__step" rsReveal="up">
        <div class="col-sm-6 center-line pd__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img3}}" alt="product-detail">
          </div>
          <div class="s-no">
            <span>03</span>
          </div>
        </div>
        <div class="col-sm-6 googlePenalty pd__copy">
          <div class="float">
            <h3>{{detail?.features?.featureDetail?.title3}}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p>{{detail?.features?.featureDetail?.features3}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- -------------------------our-business Section end----------------- -->

<!-- -------------------------our-business-mobile Section start----------------- -->
<section class="our-business-mobile rs-section pdm">
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
  </div>

  <div class="rs-shell">
    <header class="row our-business-heading mt-0 pd__head">
      <div class="col-sm-12">
        <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">What you get</span>
        <h2>{{detail?.heading}} <span class="rs-title-grad">Features</span></h2>
        <!-- <span>Top Rated SEO Agency in India</span> -->
      </div>
    </header>

    <div class="pdm__list">
      <article class="row content-one mt-5 pdm__card" rsReveal="up">
        <div class="col-sm-6 center-line pdm__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img1}}" alt="product-detail">
          </div>
          <div class="s-no">
            <span>01</span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="container float">
            <h3>{{detail?.features?.featureDetail?.title1}}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p>{{detail?.features?.featureDetail?.features1}}</p>
          </div>
        </div>
      </article>

      <article class="row content-one mt-0 pdm__card" rsReveal="up">
        <div class="col-sm-6 center-line-l pdm__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img2}}" alt="product-detail">
          </div>
          <div class="s-no-l">
            <span>02</span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="container float">
            <h3>{{detail?.features?.featureDetail?.title2}}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p class="one-p">{{detail?.features?.featureDetail?.features2}}</p>
          </div>
        </div>
      </article>

      <article class="row content-one mt-0 pdm__card" rsReveal="up">
        <div class="col-sm-6 center-line pdm__media">
          <div class="pd__frame rs-frame">
            <img loading="lazy" src="{{detail?.img?.img3}}" alt="product-detail">
          </div>
          <div class="s-no">
            <span>03</span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="container float mb-3">
            <h3>{{detail?.features?.featureDetail?.title3}}</h3>
            <span class="pd__rule" aria-hidden="true"></span>
            <p>{{detail?.features?.featureDetail?.features3}}</p>
          </div>
        </div>
      </article>
    </div>
  </div>
</section>
<!-- -------------------------our-business-mobile Section end----------------- -->
